import { fontSize } from "./fontSize";
import { iconSize } from "./iconSize";
import { spacing, arraySpacing } from "./spacing";
import { DefaultTheme } from "react-native-paper";
import { colors } from "./colors";

export type SpacingValues = keyof typeof spacing;
type Theme = typeof DefaultTheme;

export interface ThemeType extends Theme {
  spacing: typeof spacing;
  arraySpacing: typeof arraySpacing;
  colors: typeof colors & typeof DefaultTheme.colors;
  fontSize: typeof fontSize;
  iconSize: typeof iconSize;
}
export const theme = {
  ...DefaultTheme,
  spacing,
  arraySpacing,
  colors: { ...DefaultTheme.colors, ...colors },
  iconSize,
  fontSize,
} as ThemeType;
